import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { StorageService } from './../../providers/storage.service';
import { DepositRecordService } from './../../services/depositRecord.service';
import { DepositRecordModel } from './../../models/depositRecord.model';
import { LoaddingService } from './../../providers/loadding.service';
import { PageDefault } from '../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { Depositsearch } from './depositsearch';


@Component({
  selector: 'page-deposit-record',
  templateUrl: 'deposit-record.html',
  providers: [
    DepositRecordService
  ]
})
export class DepositRecordPage {

  constructor(
    public storage: StorageService,
    public depositRecordService: DepositRecordService,
    private loadding: LoaddingService,
    private modalCtrl: ModalController
  ) { }
  depRecords: DepositRecordModel[] = [];
  excludeTracks = [];
  isHave: boolean = false;
  username = this.storage.read<UserModel>("User").UserName;
  site = new DepositSearchInput();
  amount: number;
  pagesize: number = PageDefault.PageSize();
  time = new Date();
  hasmore: boolean = false;

  //查询点击事件
  record(obj:DepositSearchInput) {
    return this.depositRecordService.getDepositRecord(obj.UserName, obj.StartDate, obj.EndDate, obj.PageSize, obj.PageIndex).then(s => {
      if (s.List != null) {
        if (obj.PageIndex == 1) {
          this.depRecords = [];
          this.depRecords = s.List;
          if (s.List.length < s.PageCount) {
            this.hasmore = true;
          } else {
            this.hasmore = false;
          }
        } else {
          this.depRecords = this.depRecords.concat(s.List);
          if (this.depRecords.length < s.PageCount) {
            this.hasmore = true;
          }
          else {
            obj.PageIndex = 1;
            this.hasmore = false;
          }
        }
      } else {
        this.depRecords = [];
      }
      if (this.depRecords.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }
    });
  }



  //查询条件
  presentFilter() {
    let modal = this.modalCtrl.create(Depositsearch, this.excludeTracks);
    modal.present();
    modal.onWillDismiss((data: any[]) => {
      if (data) {
        this.excludeTracks = data;
        this.site.UserName = this.username;
        this.site.StartDate = this.excludeTracks["startDate"];
        this.site.EndDate = this.excludeTracks["endDate"];
        // this.site.PageIndex = this.excludeTracks["pageIndex"];        
        this.record(this.site);
      }
    });
  }

  //页面加载
  ionViewDidLoad() {
    let load = this.loadding.showLoding("加载中..");
    this.site.UserName = this.username;
    this.record(this.site).then(s => {
      this.loadding.closeLoading(load);
    });
  }

  //下拉重新加载
  //TQQ 2017-01-03
  doRefresh(refresher) {
    this.site.PageIndex = 1;
    this.record(this.site).then(s => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //TQQ 2017-01-03
  doInfinite(infiniteScroll) {
    this.site.PageIndex++;
    this.record(this.site).then(s => {
      infiniteScroll.complete();
    });
  }


  //近几天的快速查询
  //chen 2017-01-07
  jinDay(number) {
    let before = new Date(this.time.getTime() - number * 24 * 60 * 60 * 1000);
    this.site.StartDate = before.getFullYear() + "-" + (before.getMonth() + 1) + "-" + before.getDate();
    this.record(this.site);
  }

  //一个月内的快速查询
  //chen 2017-01-07
  jinMonth() {
    this.site.StartDate = this.time.getFullYear() + "-" + (this.time.getMonth() + 1) + "-01";
    this.record(this.site);
  }
}

export class DepositSearchInput {
  UserName: string;
  StartDate: string = PageDefault.startDate();
  EndDate: string = PageDefault.endDate();
  PageIndex: number = 1;
  PageSize: number = PageDefault.PageSize();
}



// WEBPACK FOOTER //
// ./src/pages/deposit-record/deposit-record.ts